import CandidateLayout from '@/layouts/CandidateLayout'

const Feedback = () => {
  return (
    <CandidateLayout>Feedback</CandidateLayout>
  )
}

export default Feedback